@if (showSidebar()) {
  @if (showNav()) {
    <section id="meeting-sidebar" class="is-nav-expanded" aria-label="Meeting sidebar">
      <ninety-meeting-sidenav-header
        [isPresenter]="isPresenter()"
        [meetingItemLabel]="meetingItemLabel()"
        [timers]="timers()"
        [isPaused]="isPaused()"
        [suspending]="suspending()"
        (pauseToggled)="onPauseToggled()"
        (sectionSkipped)="skipSection($event)"
        (suspended)="suspend()"
        (attendeeLeft)="exit()" />
      <div class="meeting-sidenav-divider">
        <terra-divider />
        <button
          type="button"
          class="toggle-button-wrapper toggle-nav-expanded brand-colored"
          [class.brand-light]="brandIsLight()"
          aria-label="Collapse meeting navigation"
          (click)="toggleMeetingNav()"
          [ninetyTooltip]="'Collapse'"
          [tpIsEnabled]="!isMobile()"
          tpPlacement="right">
          <terra-icon icon="caret-left" variant="bold" size="12" />
        </button>
      </div>
      <div class="meeting-sidenav-scroll">
        <ninety-meeting-sidenav-section-list
          [sections]="sections()"
          [currentSection]="currentSection()"
          [activeSectionElapsed]="sectionTime()"
          [presenterSection]="presenterFollow().presenterSection"
          [presenterAvatar]="presenterFollow().presenterAvatar"
          [outOfSyncWithPresenter]="presenterFollow().isOutOfSync"
          (sectionSelected)="onSectionSelected($event)"
          (followPresenterSelected)="onFollowPresenterSelected()" />
      </div>
      <ninety-meeting-sidenav-actions
        [showNotes]="showNotes()"
        [isPresenter]="isPresenter()"
        [canFinish]="canFinish()"
        [dayLabel]="finishDayLabel()"
        [tools]="tools()"
        [meetingId]="meetingId()"
        (tangentClicked)="onTangentClicked()"
        (toolSelected)="onToolSelected($event)"
        (notesToggled)="onNotesToggled()"
        (finishClicked)="saveAndExit()" />
    </section>
  }
}
